import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('rate.actions.text.view_rate'),
        action: (obj) => {
          this.handleOpenSidepage(obj)
        },
        meta: (obj) => ({
          validate: obj.can_update,
        }),
      },
      {
        label: i18n.t('bill.custom_rate'),
        action: (obj) => {
          this.createDialog('BillRateSetDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
            rate_id: obj.id,
            rate_set_id: this.rateSetId,
          })
        },
        hidden: (obj) => this.rateSetId === obj.rate_set_id || !obj.step_rates,
      },
      {
        label: i18n.t('system.text_153'),
        actions: obj => {
          return [
            {
              // edit
              label: i18n.t('system.text_152'),
              permission: 'rates_update',
              action: () => {
                this.createDialog('RateEditAttributesDialog', {
                  data: [obj],
                  columns: this.columns,
                  refresh: this.refresh,
                  onManager: this.onManager,
                  rateSetId: this.rateSetId,
                })
              },
              meta: () => {
                return {
                  validate: obj.can_update === true,
                }
              },
              hidden: () => this.$isScopedPolicyMenuHidden('rate_hidden_menus.rate_edit_attribute'),
            },
            {
              // delete
              label: i18n.t('system.text_129'),
              permission: 'rates_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  title: i18n.t('system.text_129'),
                  name: i18n.t('system.text_9'),
                  onManager: this.onManager,
                  data: [obj],
                  columns: this.columns,
                  refresh: this.refresh,
                  success: () => {
                    this.destroySidePages()
                  },
                })
              },
              meta: () => this.$getDeleteResult(obj),
              hidden: () => this.$isScopedPolicyMenuHidden('rate_hidden_menus.rate_delete'),
            },
          ]
        },
        hidden: () => this.rateSetId !== 'default',
      },
    ]
  },
}
